import { BaseModel } from "sjs-base-model";
import ResponseModel from "./ResponseModel";

export default class DettaglioCreditoNetModel extends BaseModel {
    public readonly idCreditoNetDetail: number = 0;
    public readonly response: ResponseModel = new ResponseModel({});

    constructor(data: Partial<DettaglioCreditoNetModel>) {
        super();

        this.update(data);
    }
}
